export enum ResourceAccess {
  PRIVATE_RESOURCES = 'Access to private resources',
  PUBLIC_RESOURCES = 'Access to public resources',
  EXPLICITLY_SHARED_RESOURCES = 'Access to explicitly shared resources',
  OWNED_RESOURCES = 'Access to owned resources',
  USER_RESOURCES_INVITE_ADMIN = 'Can invite admin',
  USER_RESOURCES_INVITE_MANAGER = 'Can invite manager',
}
